import React from 'react'
import { useState } from 'react'
import { useKhmdAddMutation } from '../../store/BnsKeJiApi'
import { Button, Modal, Form, Input, App } from 'antd'
function ContactAdd(props) {
    const {message} = App.useApp()
    const [open, setOpen] = useState(false)
    const [form] = Form.useForm()
    const [submitAdd] = useKhmdAddMutation()
    const [info,setInfo] = useState({
        khmd_phone: '',
        khmd_content: '',
        khmd_uid: props.eu_id,
        khmd_uname: props.eu_name
    })
    return (
        <>
            <Button type='primary' onClick={() => {setOpen(true)}}>新增</Button>
            <Modal
                open={open}
                title='新增客户'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    submitAdd(info).then((res) => {
                        if(res.data.Status === 'success'){
                            message.success('新增成功！')
                            setInfo({
                                khmd_phone: '',
                                khmd_content: '',
                                khmd_uid: props.eu_id,
                                khmd_uname: props.eu_name
                            })
                            setOpen(false)
                            form.resetFields()
                        }else{
                            message.error('新增失败！'+res.data.Message)
                        }
                    })
                }}
            >
                <Form 
                    form={form}
                    layout="horizontal"
                    name="form_client"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 7 }}
                >  
                    <Form.Item 
                        label="手机号码/微信号" 
                        name="khmd_phone" 
                        rules={[{ required: true, message: '请输入手机号码' }]}
                    >
                        <Input onChange={(e) => {setInfo(prevState=>({...prevState,khmd_phone:e.target.value}))}}/>
                    </Form.Item>
                    <Form.Item label="备注" name="khmd_content" rules={[{ required: true, message: '请输入备注' }]}>
                        <Input onChange={(e) => {setInfo(prevState=>({...prevState,khmd_content:e.target.value}))}}/>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default ContactAdd